export const i18nNamespace = 'muro';

//# sourceMappingURL=constants.js.map